<template>
  <div ref="formRef" class="auth-reset-link is-left">
    <FormController
      v-if="data.form && data.form.length === 1"
      :data="data.form[0]"
      :is-loading="isLoading"
      @on-submit="formAction"
    >
      <AtomButton button-type="submit" :is-disabled="isLoading" :text="data.form[0].button_text" />
    </FormController>
  </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        required: true,
    },
});

const { forgotPassword } = useStrapiAuth();

const formRef = ref(null);

const {
    isLoading,
    send,
} = useFormAction(formRef);

const redirect = computed(() => props.data?.redirect_link?.cached_url);

const formAction = (values) => {
    send(async () => {
        const submitValues = { ...values };
        delete submitValues.statusData;
        await forgotPassword(submitValues);
    }, values, `/${redirect.value}`);
};
</script>

<style lang="scss" scoped>
.auth-reset-link {
    @include default-content-columns(true);
}
</style>
